import { createSlice } from '@reduxjs/toolkit'

import { getScreen } from './getScreen'
import { ScreenModeType } from './types'

const initialState: ScreenModeType = {
  screen: getScreen(window.screen.width),
  screenHeight: window.screen.height,
  screenWidth: window.screen.width,
}
// управление состоянием экрана
export const screenModeSlice = createSlice({
  name: 'screenMode',
  initialState,
  reducers: {
    // изменение размеров экрана
    screenModeChangeSize: (state, action) => {
      const { screenWidth, screenHeight } = action.payload
      state.screenWidth = screenWidth
      state.screenHeight = screenHeight
    },
    // задается значение текущего устройства
    screenModeChangeDevice: (state, action) => {
      const { screen } = action.payload
      state.screen = screen
    },
    // reset значений в state
    screenModeReset: () => {
      return initialState
    },
  },
})

export const { screenModeChangeSize, screenModeChangeDevice, screenModeReset } =
  screenModeSlice.actions

export const screenModeReducer = screenModeSlice.reducer
